module.exports = __webpack_public_path__ + "img/8.5dbd33e9.jpg";